import React, { useEffect, useState } from 'react';
import logoGif from '../assets/SAA-Logo.gif'; // Logo principal
import loadingGif from '../assets/Cargando.gif'; // GIF de "Cargando..."

function SplashScreen({ onFinish }) {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true); // Inicia el desvanecimiento
      setTimeout(onFinish, 1000); // Termina el splash después del desvanecimiento
    }, 2000); // Mantén el splash por 2 segundos antes del desvanecimiento

    return () => clearTimeout(timer); // Limpia el temporizador
  }, [onFinish]);

  return (
    <div
      className={`flex items-center justify-center min-h-screen bg-gray-50 transition-opacity duration-1000 ${
        fadeOut ? 'opacity-0' : 'opacity-100'
      }`}
    >
      <div className="text-center">
        {/* Logo principal */}
        <img src={logoGif} alt="Logo HM" className="h-24 w-auto mx-auto mb-4" />

        {/* GIF de "Cargando..." */}
        <img src={loadingGif} alt="Cargando" className="h-24 w-auto mx-auto mb-2" />
      </div>
    </div>
  );
}

export default SplashScreen;
